module.exports = __webpack_public_path__ + "img/Alejandro_Nianez.97d56e72.jpg";